import { onBeforeMount, onBeforeUnmount } from 'vue'
import { emitter, FORCE_HIDE_RT_DIALOGS } from '@/plugins/emitter'

const OPEN_WORKGATE_POPUP_DIALOG = 'open-workgate-popup-dialog'

/**
 * WorkgateDialog の mitt 購読をまとめる。
 *
 * - グローバルポップアップ経由の開く要求
 * - 外部（useRtOutputOrchestration）からの強制クローズ。
 *   vue-final-modal は v-model で開閉するため名前指定では閉じられず、
 *   同関数が直前に出しているこのイベントで代替する（発火箇所はその1か所のみ）
 */
export function useWorkgateDialogEvents(
  vm: { dialogVisible: boolean },
  openHandler: (...args: unknown[]) => void
): void {
  const forceHide = () => {
    vm.dialogVisible = false
  }
  onBeforeMount(() => {
    emitter.on(OPEN_WORKGATE_POPUP_DIALOG, openHandler)
    emitter.on(FORCE_HIDE_RT_DIALOGS, forceHide)
  })
  onBeforeUnmount(() => {
    emitter.off(OPEN_WORKGATE_POPUP_DIALOG, openHandler)
    emitter.off(FORCE_HIDE_RT_DIALOGS, forceHide)
  })
}
